<template>
    <div class="loading-icon" :class="{'is-center': center}" :style="{ padding }"/>
</template>
<script>
export default {
    name: 'bmr-spinner',
    props: {
        center: {
            type: Boolean,
            default: false,
        },
        padding: {
            type: String,
            default: '',
        },
    },
};
</script>
<style lang="scss" scoped>
.loading-icon {
    position: relative;
    width: 3em;
    height: 3em;
    box-sizing: content-box;
    margin: 1em;
    &.is-center {
        margin-left: auto;
        margin-right: auto;
    }
    &:after {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        border: 2px solid hsl(0, 0%, 86%);
        border-width: 0.25em;
        border-top-color: transparent;
        border-right-color: transparent;
        border-radius: 9999px;
        box-sizing: border-box;
        animation: spinAround 500ms infinite linear;
    }
}

@keyframes spinAround {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(359deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/BmrSpinner.vue